import brewingBasics1 from './BrewingBasics1'
import brewingBasics2 from './BrewingBasics2'
import brewingBasics3 from './BrewingBasics3'
import brewingBasics4 from './BrewingBasics4'
import brewingBasics5 from './BrewingBasics5'
import brewingBasics6 from './BrewingBasics6'

import stateOfTheBrew1 from './StateOfTheBrew1'
import deathOfAPhoenix from './DeathOfAPhoenix'

export default [
  brewingBasics1,
  brewingBasics2,
  brewingBasics3,
  brewingBasics4,
  brewingBasics5,
  brewingBasics6,
  stateOfTheBrew1,
  deathOfAPhoenix,
]

